export default {
  powerMaint_00001: 'Charger requiring power module maintenance',
  powerMaint_00002: '!',
  powerMaint_00003: 'Timing prompt for maintenance of power module:',
  powerMaint_00004: 'Cumulative charging time from reset time',
  powerMaint_00005: 'Reset time:',
  powerMaint_00006: '{hours}Stunde',
  powerMaint_00007: 'normal',
  powerMaint_00008: 'Fehler',
  powerMaint_00009: 'Sind Sie sicher, dass Sie diese Wartung für dieses Ladepunktleistungsmodul abgeschlossen haben? Nachdem Sie auf OK geklickt haben, benötigt das Leistungsmodul eine Wartungsaufforderung, um die Zeit zu verlängern.',
  powerMaint_00010: '提示',
  powerMaint_00011: '确定',
  powerMaint_00012: '取消',
  powerMaint_00013: '成功',
  // ******
  powerMaint_10000: '需保养设备',
  powerMaint_10001: '点亮时间',
  powerMaint_10002: '已使用',
  powerMaint_10003: '小时',
  powerMaint_10004: '次',
  powerMaint_10005: '保养计时提示阀值：',
  powerMaint_10006: '重置时间起累计使用时长大于等于',
}